"use client"

import Box from "@mui/material/Box"
import Typography from "@mui/material/Typography"
import { CancelButton } from "@src/components/Button"
import Icons from "@src/components/Icons"
import { useTranslation } from "react-i18next"

const Delivery = ({ onClose }) => {
  const { t } = useTranslation("home-policy")
  const items = t("delivery.items", { returnObjects: true }) as string[]

  return (
    <Box position="relative">
      {items.map((content, index) => (
        <Typography
          key={index}
          sx={{
            display: "list-item",
            marginLeft: "20px"
          }}
          variant="body1"
          lineHeight="24px"
        >
          {content}
        </Typography>
      ))}

      <Typography mt={2} color="#D4380D" variant="body1" lineHeight="24px">
        {t("delivery.note")}
      </Typography>

      <CancelButton
        type="button"
        height="40px"
        label={t("collapse")}
        endIcon={<Icons name="arrow-up" />}
        minHeight="40px"
        minWidth="160px"
        sx={{
          margin: {
            xs: "24px auto 0",
            md: "48px auto 0"
          }
        }}
        onClick={onClose}
      />
    </Box>
  )
}

export default Delivery
